<style lang="scss" scoped="scoped">
	::-webkit-scrollbar {
		display: none;
	}
</style>
<style lang="scss">

</style>
<template>
	<div style="width: 100%;">
		<div class="titleBar" style="display: flex;margin-top: 20px;align-items:center ;">
			<!-- <div class="titleBar" style="display: flex;align-items:center ;margin-top: 36px;"> -->
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #303133;">
				{{$t('ziduanpeizhi')}}
			</p>
		</div>
		<div style="display: flex;width: 100%;justify-content: center;height: 320px;margin-top: 20px;">
			<el-transfer target-order="push" style="text-align: left; display: inline-block"
				v-model="monitorSetting.PRODUCTION_ALL_COLUMNS" :titles="[$t('yincanglie'), $t('xianshilie')]"
				:format="{
		  noChecked: '${total}',
		  hasChecked: '${checked}/${total}'
		}" @change="showColumnsChange" :data="allColumns">
				<div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;">
					<div>{{$t(option.label) }}</div>
					<div>
						<!-- <i @click="columnUp($event,option.label)" class="el-icon-bottom" style="font-size: 14px;"></i> -->
					</div>
				</div>

			</el-transfer>

		</div>
		<!-- 	<div style="display: flex;align-items: center;margin-top: 12px;">
					<div style="display: flex;flex-direction: column;">
						<el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STYLE" label="jianyue">{{$t('jianyue')}}
						</el-radio>
						<img style="width: 161px;height: 204px;margin-top: 12px;"
							src="../../../../assets/img/web/workshop/jianyue.jpg" />
					</div>
					<div style="display: flex;flex-direction: column;margin-left: 80px;">
						<el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STYLE" label="tianchong">
							{{$t('tianchong')}}
						</el-radio>
						<img style="width: 161px;height: 204px;margin-top: 12px;"
							src="../../../../assets/img/web/workshop/tianchong.jpg" />
					</div>

				</div> -->

	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_monitor_production_all_setting',
		components: {

		},

		data() {
			return {
				monitorSetting: {},
				allColumns: [{
						key: 'shebeimingcheng',
						label: this.$t('shebeimingcheng'),
						disabled: true,
					},
					{
						key: 'shengchangongdanhao',
						label: this.$t('shengchangongdanhao'),
						disabled: true,
					},
					{
						key: 'chanpinbianma',
						label: this.$t('chanpinbianma'),
						disabled: false,
					},
					{
						key: 'chanpinmingcheng',
						label: this.$t('chanpinmingcheng'),
						disabled: false,
					},
					{
						key: 'mojubianhao',
						label: this.$t('mojubianhao'),
						disabled: false,
					},
					{
						key: 'gongdanzhuangtai',
						label: this.$t('gongdanzhuangtai'),
						disabled: false,
					},
					{
						key: 'jihuashuliang',
						label: this.$t('jihuashuliang'),
						disabled: false,
					},
					{
						key: 'shengchanshuliang',
						label: this.$t('shengchanshuliang'),
						disabled: false,
					},
					{
						key: 'yibaogongliangpinshu',
						label: this.$t('yibaogongliangpinshu'),
						disabled: false,
					},
					{
						key: 'yibaogongbuliangpinshu',
						label: this.$t('yibaogongbuliangpinshu'),
						disabled: false,
					},
          {
            key: 'shengyushengchanshuliang',
            label: this.$t('shengyushengchanshuliang'),
            disabled: false,
          },
					{
						key: 'biaozhun/shishizhouqi（miao）',
						label: this.$t('biaozhun/shishizhouqi（miao）'),
						disabled: false,
					},
					{
						key: 'liangpinlv',
						label: this.$t('liangpinlv'),
						disabled: false,
					},
{
						key: 'shengchanjindu',
						label: this.$t('shengchanjindu'),
						disabled: false,
					},
					{
						key: 'wangongyuceshijian',
						label: this.$t('wangongyuceshijian'),
						disabled: false,
					},
					{
						key: 'beizhu',
						label: this.$t('beizhu'),
						disabled: false,
					},
				]
			};
		},
		created() {
			this.resetData()
		},
		activated() {
			this.resize()
		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		destroyed() {},
		methods: {
			showColumnsChange(e) {
				console.log(e)
				let index = e.indexOf('beizhu')
				if(index>0){
					e.splice(index,1)
					e.push('beizhu')
				}
				//如果有备注，把备注放最后
				//保存
				//window.localStorage.setItem("column_" + this.name, JSON.stringify(this.showColumns))
			},
			resetData() {
				//可能要防到mainjs里面去初始化,因为看板拿配置的时候setting弹框还没打开
				let monitorSetting = localStorage.getItem("MONITOR_SETTING")
				if (!monitorSetting) {
					this.monitorSetting = {}
				} else {
					this.monitorSetting = JSON.parse(monitorSetting)
				}
				
				this.monitorSetting.PRODUCTION_ALL_COLUMNS = this.monitorSetting.PRODUCTION_ALL_COLUMNS !=
					null ?
					this.monitorSetting.PRODUCTION_ALL_COLUMNS : ["shebeimingcheng", "shengchangongdanhao",
						"chanpinbianma", "chanpinmingcheng", "mojubianhao", "gongdanzhuangtai", "jihuashuliang",
						"shengchanshuliang", "yibaogongliangpinshu", "yibaogongbuliangpinshu","shengyushengchanshuliang",
						"biaozhun/shishizhouqi（miao）", "liangpinlv", "shengchanjindu",  "wangongyuceshijian", "beizhu"
					]
				this.monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE = this.monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE !=
					null ?
					this.monitorSetting.PRODUCTION_ALL_GRID_CARD_STYLE : "jianyue"

				localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting))

			},
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {

				}, 500)
			},
			save() {
				
				localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting))
				
				//首次进入的时候row可能还没出来，这时候emit row还没on，所以没有触发，这里加一个nextTick
				// this.$next
				this.utils.event_hub.$emit('SetProductionAll')
			}

		}
	};
</script>
